module.exports = __webpack_public_path__ + "static/media/CompiledNotes-screenshot.df2fae21.png";